import { __assign } from "tslib";
import * as React from 'react';
import { createLegacyBaseTableHeadCellDriver } from '../base-table-head-cell/base-table-head-cell.legacy-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
// tslint:disable-next-line:max-line-length
import { SortableTableHeadCell } from './sortable-table-head-cell';
export var createLegacySortableTableHeadCellDriver = function (wrapper) {
    var base = createLegacyBaseTableHeadCellDriver(wrapper);
    return {
        click: function () { return base.click(); },
        disabled: function () { return base.getClassNames().includes('disabled'); },
        getSortOrder: function () {
            var classNames = base.getClassNames();
            var classNamesContain = function (name) { return classNames.indexOf(name) > -1; };
            var isSortable = classNamesContain('sortable');
            var isAsc = classNamesContain('asc');
            var isDesc = classNamesContain('desc');
            return isSortable && isAsc ? 'asc' : isSortable && isDesc ? 'desc' : 'none';
        }
    };
};
export var createSortableTableHeadCell = function (props) {
    var element = renderAndMountComponent(React.createElement(SortableTableHeadCell, __assign({}, props)));
    return createLegacySortableTableHeadCellDriver(element);
};
//# sourceMappingURL=sortable-table-head-cell.legacy-driver.js.map